import React from 'react';
import styled from 'styled-components';

const Container = styled.main`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: monospace;
  font-size: 18px;
`;

class App extends React.Component {
  render() {
    return (
      <Container>
        raisio.dev()
      </Container>
    );
  }
}

export default App;
